const STORAGE_PREFIX = 'lithoform-best-level-';

const BASE_POINTS = 10;
const CLEAR_BONUS = 50;
const STREAK_MULTIPLIER = 2;

export interface ScoringState {
  score: number;
  streak: number;
}

export class Scoring {
  private score: number;
  private streak: number;
  private level: number;

  constructor(level: number, state?: ScoringState) {
    this.level = level;
    this.score = state?.score ?? 0;
    this.streak = state?.streak ?? 0;
  }

  getScore(): number {
    return this.score;
  }

  getStreak(): number {
    return this.streak;
  }

  getState(): ScoringState {
    return { score: this.score, streak: this.streak };
  }

  addPlacement(harmonyMultiplier = 1): void {
    this.score += Math.floor(BASE_POINTS * harmonyMultiplier);
  }

  addBonus(points: number): void {
    this.score += points;
  }

  addClear(lineCount: number, harmonyMultiplier = 1): void {
    this.streak++;
    const multiplier = 1 + (this.streak - 1) * (STREAK_MULTIPLIER - 1);
    this.score += Math.floor(CLEAR_BONUS * lineCount * multiplier * harmonyMultiplier);
  }

  resetStreak(): void {
    this.streak = 0;
  }

  getBestScore(): number {
    const stored = localStorage.getItem(`${STORAGE_PREFIX}${this.level}`);
    return stored ? parseInt(stored, 10) : 0;
  }

  saveBestScore(): void {
    if (this.score > this.getBestScore()) {
      localStorage.setItem(`${STORAGE_PREFIX}${this.level}`, String(this.score));
    }
  }
}
